import React, { useState, useEffect } from "react";

// Context
import { useGlobalState, useGlobalUpdater } from "../common/GlobalContext";

// Local components
import LeafletMap from "./LeafletMap";
import LeafletMapState from "./LeafletMapState";

export default function MapLayout(props) {
  const {
    mode,
    statsLayerParam,
    segmentsTable,
    segmentSelection,
    openDrawer,
  } = props;
  const query = useGlobalState();
  const dispatch = useGlobalUpdater();

  const [leafletMap, setLeafletsMap] = useState(
    <LeafletMap
      mode={mode}
      dataRoute="hpms/data"
      Zoom={8}
      position={[39.045753, -76.641273]}
      openDrawer={openDrawer}
    />
  );
  useEffect(() => {
    if (query.geoRoute === "top100/geojson")
      return setLeafletsMap(
        <LeafletMap
          mode={mode}
          dataRoute="hpms/data"
          Zoom={8}
          position={[39.045753, -76.641273]}
          openDrawer={openDrawer}
        />
      );
    else
      return setLeafletsMap(
        <LeafletMapState
          mode={mode}
          dataRoute="hpms/data"
          Zoom={8}
          position={[39.045753, -76.641273]}
          openDrawer={openDrawer}
        />
      );
  }, [query.geoRoute, query.geography.region, query.geography.county]);


  return (
    <div id={"map"} className={mode}>
      {/* <MapLayerSelect /> */}
      {query.geoRoute === "top100/geojson" && (
        <LeafletMap
          mode={mode}
          dataRoute="hpms/data"
          Zoom={8}
          position={[39.045753, -76.641273]}
          openDrawer={openDrawer}
        />
      )}{" "}
      {query.geoRoute !== "top100/geojson" && (
        <LeafletMapState
          mode={mode}
          dataRoute="hpms/data"
          Zoom={8}
          position={[39.045753, -76.641273]}
          openDrawer={openDrawer}
        />
      )}
      {/* {leafletMap} */}
    </div>
  );
}
